import React, { useEffect, useState } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    deleteStation,
    getStations,
    selectStation,
    stationsError
} from '../store/actions/stationsActions';
import {toggleModal} from '../store/actions/toggleModalActions';
import './Stations.scss';

import List from './_common/List';
import StationsMap from './StationsMap';
import StationDetails from './StationDetails';
import DeleteModal from './_common/DeleteModal';
import ErrorModal from './_common/ErrorModal';

const selector = state => {
    const { language, stations, modalState } = state;
    return {
        t: language.translator,
        pending: stations.pending,
        stations: stations.stations,
        selected: stations.selected,
        error: stations.error,
        modalState: modalState
    };
};

const Stations = () => {
    const { t, pending, stations, selected, error, modalState } = useSelector(selector);
    const dispatch = useDispatch();
    const [stationsList, setStationsList] = useState([]);
    const [showAddStationForm, setShowAddStationForm] = useState(false);
    const [showEditStationForm, setShowEditStationForm] = useState(false);
    const [mapCenterCoordinates, setMapCenterCoordinates] = useState({lat: 52.237049, lng: 21.017532});
    const [mapZoom, setMapZoom] = useState(5.8);

    useEffect(() => {
        dispatch(getStations({}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch(selectStation({}));
        setMapCenterCoordinates({lat: 52.237049, lng: 21.017532});
        setMapZoom(5.8);
        setStationsList(stations);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stations]);

    const createMapMarkers = () => {
        let stationMarkers = [];

        if(stationsList.length) {
            stationsList.forEach(station => {
                if (station.lat && station.lon) {
                    stationMarkers.push(
                      {
                          lat: station.lat,
                          lng: station.lon,
                          name: station.name,
                          chartId: station.chartId,
                          city: station.city,
                          id: station.id,
                          color: '#125172'
                      }
                    )
                }
            });
        }

        return stationMarkers
    }

    const handleStationClick = id => {
        const station = id ? stations.find(station => station.id === id) : {};
        setShowAddStationForm(false);
        dispatch(selectStation(station));
        if(station.lat && station.lon) {
            setMapZoom(15);
            setMapCenterCoordinates({lat: station.lat, lng: station.lon});
        }
    };

    const openAddStationForm = async () => {
        await dispatch(selectStation({}));
        setShowEditStationForm(false);
        setShowAddStationForm(true);
    };

    const openEditStationForm = id => {
        setShowAddStationForm(false);
        dispatch(selectStation(id ? stations.find(station => station.id === id) : {}));
        setShowEditStationForm(true);
    };

    const openDeleteStationModal = id => {
        dispatch(selectStation(stations.find(station => station.id === id)));
        dispatch(toggleModal(true, 'deleteStation'));
    };

    return (
        <div className='page'>
            <>
                <div className='pageHeader'>
                    <div className='pageHeaderLeft'>
                        <div className='pageHeaderTitle'>
                            {t.gettext('Meteo stations management')}
                        </div>
                    </div>
                </div>
                <div className='Stations'>
                    <div className='column column60 column--first'>

                        <div className='columnHeader'>
                            <div className='columnHeaderLeft'>
                                {t.gettext('Meteo stations list')}
                            </div>
                            <div className='columnHeaderRight'>
                                <button className='columnHeaderButton' onClick={openAddStationForm}>
                                    <span className="material-icons columnHeaderButtonIcon">
                                        add
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className='stationsListWrapper'>
                            <List
                                pending={pending}
                                items={stations}
                                columnsTitles={['Name', 'City', 'Latitude', 'Longitude', 'Chart Id']}
                                columnsSources={['name', 'city', 'lat', 'lon', 'chartId']}
                                columnsWidths={['20%', '20%', '20%', '20%', '20%']}
                                selectMethod={handleStationClick}
                                editMethod={openEditStationForm}
                                deleteMethod={openDeleteStationModal}
                                selectedItem={Object.keys(selected).length !== 0 && selected.constructor === Object
                                    ? selected.id
                                    : null
                                }
                            />
                        </div>

                        {modalState.flag && modalState.modal === 'deleteStation' &&
                            <DeleteModal
                                id={selected.id}
                                itemName={selected.name}
                                title='Delete meteo station'
                                deleteMethod={() => dispatch(deleteStation(selected.id))}
                                closeMethod={() => dispatch(toggleModal(false, ''))}
                            />
                        }

                        {!!error &&
                            <ErrorModal
                                error={error}
                                closeMethod={() => dispatch(stationsError(''))}
                            />
                        }
                    </div>
                    <div className='column column40'>
                        {/*{Object.keys(selected).length !== 0 && selected.constructor === Object &&*/}
                        {/*    <StationsMap*/}
                        {/*      defaultZoom={5.8}*/}
                        {/*      defaultCenter={{lat: 52.2297, lng: 21.0122}}*/}
                        {/*      markers={stationMarkers}*/}
                        {/*    />*/}
                        {/*}*/}
                        {!showEditStationForm && !showAddStationForm &&
                            <StationsMap
                              zoom={mapZoom}
                              center={mapCenterCoordinates}
                              markers={createMapMarkers()}
                            />
                        }
                        {showEditStationForm &&
                            <StationDetails
                              station={selected}
                              closeForm={() => setShowEditStationForm(false)}
                            />
                        }
                        {showAddStationForm &&
                            <StationDetails
                              closeForm={() => setShowAddStationForm(false)}
                            />
                        }
                    </div>
                </div>
            </>
        </div>
    );
};

export default Stations;
